var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple24X24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.644 17.497a10.76 10.76 0 0 1-1.085 1.922c-.571.802-1.038 1.357-1.398 1.665-.558.505-1.156.764-1.797.78-.46 0-1.014-.13-1.659-.391-.647-.26-1.242-.39-1.786-.39-.571 0-1.183.13-1.837.39-.656.261-1.184.398-1.588.411-.614.026-1.226-.24-1.837-.8-.39-.335-.878-.91-1.462-1.724-.627-.869-1.142-1.877-1.546-3.025C3.217 15.094 3 13.892 3 12.728c0-1.332.292-2.482.878-3.445a5.11 5.11 0 0 1 1.838-1.832 5 5 0 0 1 2.485-.69c.488 0 1.127.148 1.922.44.793.293 1.302.442 1.525.442.166 0 .732-.174 1.69-.52.907-.322 1.671-.455 2.298-.402 1.698.135 2.974.794 3.822 1.982-1.519.907-2.27 2.177-2.255 3.806.014 1.268.481 2.324 1.4 3.163.415.389.88.69 1.397.903-.112.32-.23.627-.356.922Zm-3.895-15.1c0 .995-.368 1.924-1.103 2.783-.887 1.022-1.96 1.613-3.124 1.52a3.056 3.056 0 0 1-.023-.377c0-.955.422-1.977 1.17-2.812.375-.423.85-.775 1.427-1.056.576-.276 1.12-.429 1.632-.455.015.133.021.266.021.398Z",
    fill: "#0B0204"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple24X24);
export default __webpack_public_path__ + "static/media/apple-24x24.ae1176e0492b6b76131a1ebfde687d87.svg";
export { ForwardRef as ReactComponent };